/** @jsxImportSource @emotion/react */

import { SkeletonCustomStyle } from "./style.index";

export interface SkeletonProps {
  height: string;
  width?: string;
  background?: string;
}
const SkeletonCustom = ({ height, width, background }: SkeletonProps) => {
  return (
    <div
      css={SkeletonCustomStyle.index({
        height: height,
        width: width,
        background: background
      })}
    />
  );
};

export default SkeletonCustom;
